var _typeof = require("D:\\Tagrail\\source\\repo\\tg-dailyco-videochat-script\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/typeof");

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : e.ReactNewWindow = t(e.React, e.ReactDOM);
}(this, function (e, t) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e, t = t && t.hasOwnProperty("default") ? t.default : t;

  var n = function n(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  };

  function o(e, t) {
    for (var n = 0; n < t.length; n++) {
      var o = t[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  var r = function r(e, t, n) {
    return t && o(e.prototype, t), n && o(e, n), e;
  };

  function i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function c(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var s = c(function (e) {
    function t(e) {
      return (t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function n(o) {
      return "function" == typeof Symbol && "symbol" === t(Symbol.iterator) ? e.exports = n = function n(e) {
        return t(e);
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : t(e);
      }, n(o);
    }

    e.exports = n;
  });

  var u = function u(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  };

  var a = function a(e, t) {
    return !t || "object" !== s(t) && "function" != typeof t ? u(e) : t;
  },
      l = c(function (e) {
    function t(n) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, t(n);
    }

    e.exports = t;
  }),
      f = c(function (e) {
    function t(n, o) {
      return e.exports = t = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, t(n, o);
    }

    e.exports = t;
  });

  var p = function p(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && f(e, t);
  };

  var d = function d(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  },
      y = c(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "function" == typeof Symbol && Symbol.for,
        o = n ? Symbol.for("react.element") : 60103,
        r = n ? Symbol.for("react.portal") : 60106,
        i = n ? Symbol.for("react.fragment") : 60107,
        c = n ? Symbol.for("react.strict_mode") : 60108,
        s = n ? Symbol.for("react.profiler") : 60114,
        u = n ? Symbol.for("react.provider") : 60109,
        a = n ? Symbol.for("react.context") : 60110,
        l = n ? Symbol.for("react.async_mode") : 60111,
        f = n ? Symbol.for("react.concurrent_mode") : 60111,
        p = n ? Symbol.for("react.forward_ref") : 60112,
        d = n ? Symbol.for("react.suspense") : 60113,
        y = n ? Symbol.for("react.memo") : 60115,
        m = n ? Symbol.for("react.lazy") : 60116;

    function w(e) {
      if ("object" == _typeof(e) && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            switch (e = e.type) {
              case l:
              case f:
              case i:
              case s:
              case c:
              case d:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case a:
                  case p:
                  case u:
                    return e;

                  default:
                    return t;
                }

            }

          case m:
          case y:
          case r:
            return t;
        }
      }
    }

    function h(e) {
      return w(e) === f;
    }

    t.typeOf = w, t.AsyncMode = l, t.ConcurrentMode = f, t.ContextConsumer = a, t.ContextProvider = u, t.Element = o, t.ForwardRef = p, t.Fragment = i, t.Lazy = m, t.Memo = y, t.Portal = r, t.Profiler = s, t.StrictMode = c, t.Suspense = d, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === f || e === s || e === c || e === d || "object" == _typeof(e) && null !== e && (e.$$typeof === m || e.$$typeof === y || e.$$typeof === u || e.$$typeof === a || e.$$typeof === p);
    }, t.isAsyncMode = function (e) {
      return h(e) || w(e) === l;
    }, t.isConcurrentMode = h, t.isContextConsumer = function (e) {
      return w(e) === a;
    }, t.isContextProvider = function (e) {
      return w(e) === u;
    }, t.isElement = function (e) {
      return "object" == _typeof(e) && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return w(e) === p;
    }, t.isFragment = function (e) {
      return w(e) === i;
    }, t.isLazy = function (e) {
      return w(e) === m;
    }, t.isMemo = function (e) {
      return w(e) === y;
    }, t.isPortal = function (e) {
      return w(e) === r;
    }, t.isProfiler = function (e) {
      return w(e) === s;
    }, t.isStrictMode = function (e) {
      return w(e) === c;
    }, t.isSuspense = function (e) {
      return w(e) === d;
    };
  });

  i(y);
  y.typeOf, y.AsyncMode, y.ConcurrentMode, y.ContextConsumer, y.ContextProvider, y.Element, y.ForwardRef, y.Fragment, y.Lazy, y.Memo, y.Portal, y.Profiler, y.StrictMode, y.Suspense, y.isValidElementType, y.isAsyncMode, y.isConcurrentMode, y.isContextConsumer, y.isContextProvider, y.isElement, y.isForwardRef, y.isFragment, y.isLazy, y.isMemo, y.isPortal, y.isProfiler, y.isStrictMode, y.isSuspense;
  var m = c(function (e, t) {});
  i(m);
  m.typeOf, m.AsyncMode, m.ConcurrentMode, m.ContextConsumer, m.ContextProvider, m.Element, m.ForwardRef, m.Fragment, m.Lazy, m.Memo, m.Portal, m.Profiler, m.StrictMode, m.Suspense, m.isValidElementType, m.isAsyncMode, m.isConcurrentMode, m.isContextConsumer, m.isContextProvider, m.isElement, m.isForwardRef, m.isFragment, m.isLazy, m.isMemo, m.isPortal, m.isProfiler, m.isStrictMode, m.isSuspense, c(function (e) {
    e.exports = y;
  });
  var w = Object.getOwnPropertySymbols,
      h = Object.prototype.hasOwnProperty,
      b = Object.prototype.propertyIsEnumerable;
  (function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  })() && Object.assign;
  var v = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  Function.call.bind(Object.prototype.hasOwnProperty);

  function S() {}

  function O() {}

  O.resetWarningCache = S;

  var g = c(function (e) {
    e.exports = function () {
      function e(e, t, n, o, r, i) {
        if (i !== v) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: O,
        resetWarningCache: S
      };
      return n.PropTypes = n, n;
    }();
  }),
      P = function (e) {
    function o(e) {
      var t;
      return n(this, o), (t = a(this, l(o).call(this, e))).container = document.createElement("div"), t.window = null, t.windowCheckerInterval = null, t.released = !1, t.state = {
        mounted: !1
      }, t;
    }

    return p(o, e), r(o, [{
      key: "render",
      value: function value() {
        return this.state.mounted ? t.createPortal(this.props.children, this.container) : null;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.openChild(), this.setState({
          mounted: !0
        });
      }
    }, {
      key: "openChild",
      value: function value() {
        var e,
            t = this,
            n = this.props,
            o = n.url,
            r = n.title,
            i = n.name,
            c = n.features,
            s = n.onBlock,
            u = n.onOpen,
            a = n.center;

        if ("string" != typeof a || void 0 !== c.width && void 0 !== c.height) {
          if ("parent" === a) c.left = window.top.outerWidth / 2 + window.top.screenX - c.width / 2, c.top = window.top.outerHeight / 2 + window.top.screenY - c.height / 2;else if ("screen" === a) {
            var l = void 0 !== window.screenLeft ? window.screenLeft : window.screen.left,
                f = void 0 !== window.screenTop ? window.screenTop : window.screen.top,
                p = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width,
                d = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
            c.left = p / 2 - c.width / 2 + l, c.top = d / 2 - c.height / 2 + f;
          }
        } else console.warn("width and height window features must be present when a center prop is provided");

        this.window = window.open(o, i, (e = c, Object.keys(e).reduce(function (t, n) {
          var o = e[n];
          return "boolean" == typeof o ? t.push("".concat(n, "=").concat(o ? "yes" : "no")) : t.push("".concat(n, "=").concat(o)), t;
        }, []).join(","))), this.windowCheckerInterval = setInterval(function () {
          t.window && !t.window.closed || t.release();
        }, 50), this.window ? (this.window.document.title = r, this.window.document.body.appendChild(this.container), this.props.copyStyles && setTimeout(function () {
          return e = document, n = t.window.document, void Array.from(e.styleSheets).forEach(function (t) {
            var o;

            try {
              o = t.cssRules;
            } catch (e) {
              console.error(e);
            }

            if (o) {
              var r = e.createElement("style");
              Array.from(t.cssRules).forEach(function (t) {
                var n = t.cssText,
                    o = t.type,
                    i = n;
                [3, 5].includes(o) && (i = n.split("url(").map(function (e) {
                  return "/" === e[1] ? "".concat(e.slice(0, 1)).concat(window.location.origin).concat(e.slice(1)) : e;
                }).join("url(")), r.appendChild(e.createTextNode(i));
              }), n.head.appendChild(r);
            } else if (t.href) {
              var i = e.createElement("link");
              i.rel = "stylesheet", i.href = t.href, n.head.appendChild(i);
            }
          });
          var e, n;
        }, 0), "function" == typeof u && u(this.window), this.window.addEventListener("beforeunload", function () {
          return t.release();
        })) : "function" == typeof s ? s(null) : console.warn("A new window could not be opened. Maybe it was blocked.");
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.window && this.window.close();
      }
    }, {
      key: "release",
      value: function value() {
        if (!this.released) {
          this.released = !0, clearInterval(this.windowCheckerInterval);
          var e = this.props.onUnload;
          "function" == typeof e && e(null);
        }
      }
    }]), o;
  }(e.PureComponent);

  return d(P, "defaultProps", {
    url: "",
    name: "",
    title: "",
    features: {
      width: "600px",
      height: "640px"
    },
    onBlock: null,
    onOpen: null,
    onUnload: null,
    center: "parent",
    copyStyles: !0
  }), P.propTypes = {
    children: g.node,
    url: g.string,
    name: g.string,
    title: g.string,
    features: g.object,
    onUnload: g.func,
    onBlock: g.func,
    onOpen: g.func,
    center: g.oneOf(["parent", "screen"]),
    copyStyles: g.bool
  }, P;
});